import { StaticImageData } from 'next/image'
import AdvantagesExtractImage1x from './builder-advantages-extract@1x.png'
import AdvantagesExtractImage2x from './builder-advantages-extract@2x.png'
import AdvantagesMapImage1x from './builder-advantages-map@1x.png'
import AdvantagesMapImage2x from './builder-advantages-map@2x.png'
import AdvantagesTestImage1x from './builder-advantages-test@1x.png'
import AdvantagesTestImage2x from './builder-advantages-test@2x.png'

export type BuilderAdvantagesDataType = {
  title: string
  subtitle: string
  image1x: StaticImageData
  image2x: StaticImageData
  name: string
  imageWidth: string
  imageHeight: string
}

export const builderAdvantagesData: BuilderAdvantagesDataType[] = [
  {
    title:
      'Automatically extract operations, data collections, fields schemas, and other entities from an API using LLM-powered features',
    subtitle:
      'Map each individual application API to a standard set of entities your application can work with in a consistent way.',
    image1x: AdvantagesExtractImage1x,
    image2x: AdvantagesExtractImage2x,
    name: 'Extract',
    imageWidth: '539',
    imageHeight: '286',
  },
  {
    title: 'Map application-specific entities to Universal Models',
    subtitle:
      'Universal models let you integrate with multiple similar applications at once. Our connector builder helps you map application-specific entities to universal ones.',
    image1x: AdvantagesMapImage1x,
    image2x: AdvantagesMapImage2x,
    name: 'Map',
    imageWidth: '532',
    imageHeight: '303',
  },
  {
    title: 'Test connectors manually or automatically',
    subtitle:
      "Our comprehensive testing framework makes sure you don't have mismatched fields or incorrect API requests. Your connectors work from the first version and keep working.",
    image1x: AdvantagesTestImage1x,
    image2x: AdvantagesTestImage2x,
    name: 'Test',
    imageWidth: '508',
    imageHeight: '377',
  },
]
